module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Sun-glasses-64be6718acdfea29adc895a307a728d9.svg";